module.exports = __webpack_public_path__ + "img/mouse-down.1f47e687.svg";